<template>
  <HeraConfirm
    v-bind="{
      title: $$t('Helper calculator'),
      text: $$t('Info Text', 'helper-calculator_info'),
      confirmButtonText: $$t('Apply', 'swiss-apply-rounds-count'),
      confirmButtonDisabled:
        isStageFieldDisabled('swissHelp') ||
        !swissRecommendedRoundsCount ||
        !!errors.first('swiss-prize-places-count') ||
        !!errors.first('help-swiss-participants-count') ||
        disabled,
    }"
    v-on="{
      cancel: closeModal,
      confirm: onConfirm,
    }"
  >
    <div class="row">
      <div class="col">
        <div class="d-flex flex-column">
          <!-- <TextBlock tag="h4" :size="calcHelperTextSize" variant="muted">
          <Icon
            name="calculator"
            fill="currentColor"
            class="h-mr-2"
            width="24"
          />
          {{ $$t('Helper calculator') }}
        </TextBlock>
        <TextBlock :size="calcHelperTextSize" variant="muted" class="my-3">
          {{ $$t('Info Text', 'helper-calculator_info') }}
        </TextBlock> -->
          <div class="row d-flex align-items-center my-5">
            <div class="col">
              <HeraFormInput
                key="swiss-participants-count"
                v-model="swissParticipantsCount"
                v-validate="'numeric|decimal:0|min_value:2'"
                variant="flat"
                size="2"
                :label="
                  $$t(
                    'Please provide us participants in group:',
                    'swiss-rounds-help-part1'
                  )
                "
                :class="{
                  'is-invalid': errors.first('help-swiss-participants-count'),
                }"
                class="swiss-help-input w-auto"
                name="help-swiss-participants-count"
                :data-vv-as="
                  $$t(
                    'Participants in a group',
                    'swiss-participants-count-placeholder'
                  )
                "
                :disabled="disabled"
                :error="errors.first('help-swiss-participants-count')"
                error-in-tooltip
                placeholder="0"
              />
            </div>
            <div class="col">
              <HeraFormInput
                key="swiss-prize-places-count"
                v-model="swissPrizePlacesCount"
                v-validate="swissPrizePlacesCountValidationRule"
                variant="flat"
                size="2"
                :label="
                  $$t('and number of prize places:', 'swiss-rounds-help-part2')
                "
                :class="{
                  'is-invalid': errors.first('swiss-prize-places-count'),
                }"
                class="swiss-help-input w-auto"
                name="swiss-prize-places-count"
                :data-vv-as="
                  $$t('Number of prize places', 'swiss-prize-count-placeholder')
                "
                :disabled="disabled"
                :error="errors.first('swiss-prize-places-count')"
                error-in-tooltip
                placeholder="0"
              />
            </div>
          </div>
          <TextBlock :size="calcHelperTextSize" variant="muted">
            {{ $$t('Recommended rounds', 'swiss-rounds-help-part3-test') }}
          </TextBlock>
          <TextBlock :size="1.25">
            {{ swissRecommendedRoundsCount }}
          </TextBlock>
        </div>
      </div>
    </div>
  </HeraConfirm>
</template>

<script>
import { mapActions } from 'vuex';
import { translate } from '@/mixins/translate';
// import Icon from '@/components/atoms/Icon';
import HeraConfirm from '@/components/modal/children/HeraConfirm.vue';
import TextBlock from '@/components/atoms/TextBlock';
// import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import HeraFormInput from '@/components/atoms/form/HeraFormTextInput';
import stageSetupHelpers from '@/views/tournaments/management/singleTournament/mixins/stageHelpers';
import { prop } from '@/utils/factories';
export default {
  name: 'StageSwissCalculatorHelper',
  components: {
    // Icon,
    TextBlock,
    HeraConfirm,
    HeraFormInput,
  },
  inject: ['$validator'],
  mixins: [translate('_web_tournament_stage-editor'), stageSetupHelpers],
  props: {
    disabled: prop(Boolean),
  },
  data() {
    return {
      swissParticipantsCount: null,
      swissPrizePlacesCount: null,
      calcHelperTextSize: 0.85,
    };
  },
  computed: {
    swissRecommendedRoundsCount() {
      return this.swissParticipantsCount && this.swissPrizePlacesCount
        ? Math.ceil(
            Math.log2(this.swissParticipantsCount) +
              (this.swissPrizePlacesCount > 1
                ? Math.log2(this.swissPrizePlacesCount - 1)
                : 0)
          )
        : 0;
    },
    swissPrizePlacesCountValidationRule() {
      return `numeric|decimal:0|min_value:1|max_value:${
        this.swissParticipantsCount
      }`;
    },
  },
  methods: {
    ...mapActions(['openModal', 'closeModal']),
    onConfirm() {
      this.setBlockConfigurationByKey(
        'rounds',
        +this.swissRecommendedRoundsCount
      );
      this.closeModal();
    },
  },
};
</script>

<style></style>
